<script setup lang="ts">
// Componente mínimo para começar a integrar sua lógica depois
// Dica: você pode remover o lang="ts" se não estiver usando TypeScript
// Nome do componente (útil para DevTools e roteamento dinâmico)
// Disponível a partir do Vue 3.3+
// Se estiver em versão anterior, pode ignorar isto.
// @ts-ignore
defineOptions({ name: 'ScheduleCampaignList' });
</script>

<!-- CampaignConfigureList.vue -->
<template>
    <div class="border border-green-100 dark:border-green-800 bg-green-50 dark:bg-green-900/10 h-full p-6 w-full max-w-full md:w-3/4 md:max-w-[75%] flex-shrink-0 flex-grow-0">
    <h1 class="text-2xl font-semibold leading-tight">Hello, World seu baica👋</h1>
    <p class="mt-1 text-sm text-gray-600 dark:text-gray-400">
      <code>CampaignConfigureList.vue</code> está carregado com sucesso.
    </p>
  </div>
</template>



<style scoped>
/* Estilos opcionais adicionais (além do Tailwind) */
</style>
